export default [
	[
		{
			index: 'title',
			header: {
				title: 'title'
			},
			column: {}
		},
		{
			index: 'width',
			header: {
				title: 'width'
			},
			column: {}
		},
		{
			index: 'height',
			header: {
				title: 'height'
			},
			column: {}
		},
		{
			index: 'id',
			header: {
				title: 'id'
			},
			column: {}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/campaign/list/table-initial-data.js